import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "create-item"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "item-content"
};
var _hoisted_4 = {
  class: "item-info"
};
var _hoisted_5 = {
  class: "create-footer"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "num"
};
var _hoisted_8 = {
  key: 0,
  class: "check-box"
};
import { MessagePlugin } from 'tdesign-vue-next';
import { env_name } from '@/util/util.js';
import { getStore } from '@/util/store';
import { getCourseVersion } from '@/api/resources.js';
import { giveLike } from '@/api/personalHomepage';
import { watch, ref } from 'vue';
export default {
  __name: 'createItem',
  props: {
    data: {
      type: Object,
      default: function _default() {}
    },
    spaceHideFlag: {
      type: Number,
      default: 0
    },
    isCheckModule: {
      type: Boolean,
      default: false
    },
    clickRightValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['like'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var props = __props;
    var whiteStar = require('@/assets/home/star.svg');
    var redStar = require('@/assets/home/red-star.svg');
    var accessInfo = getStore({
      name: 'accessInfo'
    }); // 获取accessInfo
    // const access_token = getStore({ name: "access_token" }); // 传递token到子应用
    var flag = ref(false);
    var disable = ref(false);
    // 查看详情
    var commonName = env_name ? "//".concat(env_name, "course.zhixuehuijiao.cn") : '//edu-course.zhixuehuijiao.cn';
    var lookDetail = function lookDetail(val) {
      getCourseVersion(val.id).then(function (res) {
        if (res.data.code === 0) {
          if (res.data.data === 2) {
            // 新学程预览
            window.open("".concat(commonName, "/preview?courseId=").concat(val.id, "&version=2"));
          } else {
            // 旧学程预览
            window.open("/courseDetail?id=".concat(val.id, "&source=2&accountType=").concat(accessInfo.accountType));
          }
        }
      });
    };
    // 点赞
    var handleLikeClick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var id, isLike, opType;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              id = val.id, isLike = val.isLike;
              opType = isLike === 0 ? 1 : 0;
              _context.n = 1;
              return giveLike(id, 5, opType);
            case 1:
              emit('like', 'create');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function handleLikeClick(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    watch(function () {
      return props;
    }, function (val) {
      var data = val.data,
        spaceHideFlag = val.spaceHideFlag;
      if (spaceHideFlag == 1) {
        //1隐藏
        flag.value = data.spaceHideFlag === 1 ? true : false;
        disable.value = data.spaceHideFlag === 1 ? true : false;
      } else {
        //0公开
        flag.value = data.spaceHideFlag === 0 ? true : false;
        disable.value = data.spaceHideFlag === 0 ? true : false;
      }
    }, {
      deep: true,
      immediate: true
    });
    var handleChange = function handleChange(val) {
      console.log(val, '--handleChange');
      emit('changeFlag', props.data.id);
    };
    return function (_ctx, _cache) {
      var _component_t_checkbox = _resolveComponent("t-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        class: "img",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return lookDetail(__props.data);
        }),
        src: __props.data.cover,
        alt: ""
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", {
        class: "title",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return lookDetail(__props.data);
        })
      }, _toDisplayString(__props.data.name), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(__props.data.originalAuthorOrCreateOr), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(__props.data.time), 1), _createElementVNode("div", {
        class: "right-box",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return handleLikeClick(__props.data);
        })
      }, [_createElementVNode("img", {
        src: __props.data.isLike === 0 ? _unref(redStar) : _unref(whiteStar),
        alt: ""
      }, null, 8, _hoisted_6), _createElementVNode("span", _hoisted_7, _toDisplayString(__props.data.likeCount), 1)])])]), __props.isCheckModule && __props.clickRightValue === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_t_checkbox, {
        modelValue: flag.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return flag.value = $event;
        }),
        disabled: disable.value,
        onChange: handleChange
      }, null, 8, ["modelValue", "disabled"])])) : _createCommentVNode("", true), __props.clickRightValue === 1 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['tip', __props.data.spaceHideFlag === 1 ? 'hide' : 'open'])
      }, _toDisplayString(__props.data.spaceHideFlag === 1 ? '已隐藏' : '已公开'), 3)) : _createCommentVNode("", true)]);
    };
  }
};